import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash/lang';
import { translate } from 'react-i18next';

import i18n from '../../i18n';
import IdentificationForm from '../IdentificationForm/';
import SimpleBox from '../../components/SimpleBox/';
import ErrorMessage from '../../components/Messages/ErrorMessage';
import TimeSlotCard from '../../components/TimeSlotCard/';
import AppIcon from '../../components/AppIcon';
import { transformReservationsToTimeSlot } from '../../util/helpers';

class CancelReservation extends Component {

  constructor(props) {
    super(props);
    this.onHideModal = this.onHideModal.bind(this);
    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.sendReservationCode = this.sendReservationCode.bind(this);
    this.confirmCancelling = this.confirmCancelling.bind(this);
    this.initialState = {
      formValues: {},
      sendReservationCodeButtonDisabled: true
    };
    this.state = this.initialState;
  }

  onHideModal() {
    this.setState(this.initialState);
    this.props.closeCancelReservationScreen();
  }

  sendReservationCode(event) {
    event.preventDefault();
    this.props.fetchReservation(this.state.formValues.reservationCode);
  }

  handleFormInputChange(event) {
    const { id: fieldName, value } = event.target;
    this.setState({
      formValues: {
        ...this.state.formValues,
        [fieldName]: value
      }
    }, this.validateFields);
  }

  validateFields() {
    const { reservationCode } = this.state.formValues;
    const allFieldsValid = (reservationCode.length > 0);
    this.setState({ sendReservationCodeButtonDisabled: !allFieldsValid });
  }

  confirmCancelling() {
    this.props.cancelReservation(this.props.reservation.reservation);
  }

  render() {
    const {
      show, userIdentified, fetchingReservationError, reservation,
      reservationCancelled, cancellingReservationError, t
    } = this.props;

    let currentPhase;
    let textKey;

    if (!userIdentified) {
      currentPhase = (
        <SimpleBox>
          <div className="box-header">
            <h1>{t('cancelReservation.loginFirstTitle')}</h1>
            <p>{t('cancelReservation.loginFirstText')}</p>
          </div>
          <IdentificationForm />
        </SimpleBox>
      );
    } else if (isEmpty(reservation)) {
      currentPhase = (
        <SimpleBox>
          <div className="box-header">
            <h1>{t('cancelReservation.insertReservationCodeTitle')}</h1>
          </div>
          <div>
            <form className="reservation-number-form" onSubmit={this.sendReservationCode}>
              <div className="form-input-group">
                <input
                  id="reservationCode"
                  type="text"
                  placeholder={t('cancelReservation.reservationCodePlaceholder')}
                  onChange={this.handleFormInputChange}
                />
              </div>
              <ErrorMessage isVisible={!isEmpty(fetchingReservationError)}>
                <strong>{t(`cancelReservation.${fetchingReservationError}`)}</strong>
                <p>{t('cancelReservation.checkReservationCodeMessage')}</p>
              </ErrorMessage>
              <Button
                className="action-btn center-block"
                type="submit"
                disabled={this.state.sendReservationCodeButtonDisabled}
              >
                {t('cancelReservation.searchForReservationButton')}
              </Button>
            </form>
          </div>
        </SimpleBox>
      );
    } else if (!reservationCancelled) {
      console.log('Inserting unit', this.props.units, this.props.reservation.unit);
      currentPhase = (
        <SimpleBox>
          <div className="text-center">
            <div className="box-header">
              <h1>{t('cancelReservation.confirmCancellingTitle')}</h1>
            </div>
            <TimeSlotCard
              timeSlot={transformReservationsToTimeSlot(reservation, this.props.resources, t)}
              t={t}
              onClick={reservation.canBeCancelled ? this.confirmCancelling : null}
              disabled={!reservation.canBeCancelled}
              unit={this.props.units[this.props.reservation.unit]}
              actionElement={reservation.canBeCancelled ? <span className="time-slot-action-text">{t('cancelReservation.cancelButton')}</span> : <p />}
            />
            { !reservation.canBeCancelled &&
              <span>{t('cancelReservation.notCancelableReason')}</span>
            }
            <ErrorMessage isVisible={!isEmpty(cancellingReservationError)}>
              <strong>{i18n.exists(`cancelReservation.${cancellingReservationError}`) ? t(`cancelReservation.${cancellingReservationError}`) : t(`genericErrorMessage`)}</strong>
            </ErrorMessage>
          </div>
        </SimpleBox>
      );
    } else {
      textKey = this.props.reservationWasAlreadyCancelled ? 'alreadyCancelled' : 'reservationCancelledTitle';
      currentPhase = (
        <SimpleBox>
          <div className="reservation-cancelled-phase text-center">
            <div className="box-header">
              <h1>{t(`cancelReservation.${textKey}`)}</h1>
              <p>{t(`cancelReservation.reservationCancelledInfoText`)}</p>
            </div>
            <div className="reservation-cancelled-actions">
              <Button
                className="action-btn action-btn-logout"
                onClick={this.props.logout}
              >
                {t('logoutButton')}
              </Button>
              <Button
                className="action-btn action-btn-back"
                onClick={this.onHideModal}
              >
                {t('cancelReservation.backToBooking')}
              </Button>
            </div>
          </div>
        </SimpleBox>
      );
    }

    return (
      <Modal
        className="cancel-reservation-screen"
        show={show}
        backdrop="static"
        keyboard={false}
        onHide={() => { this.onHideModal() }}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={() => { this.onHideModal() }}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        {currentPhase}
      </Modal>
    );
  }
}

CancelReservation.propTypes = {
  show: PropTypes.bool.isRequired,
  userIdentified: PropTypes.bool.isRequired,
  closeCancelReservationScreen: PropTypes.func.isRequired,
  fetchReservation: PropTypes.func.isRequired,
  fetchingReservationError: PropTypes.string,
  reservation: PropTypes.object,
  cancelReservation: PropTypes.func.isRequired,
  cancellingReservationError: PropTypes.string,
  reservationCancelled: PropTypes.bool,
  reservationWasAlreadyCancelled: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  resources: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
  units: PropTypes.shape({})
};

CancelReservation.defaultProps = {
  fetchingReservationError: '',
  reservation: {},
  cancellingReservationError: '',
  reservationCancelled: false,
  resources: {},
  units: {},
  user: {},
  reservationWasAlreadyCancelled: false
};


export default translate(['booking'])(CancelReservation);



// WEBPACK FOOTER //
// ./src/containers/CancelReservation/CancelReservation.jsx